<!-- NEWDESIGN DONE -->
@if ((internetConnectionService.isConnected$ | async) === false) {
<div class="fixed z-above left-0 right-safeIntercom bottom-safeBottom p-4">
  <div class="relative rounded bg-v2-rose-600 text-v2-white text-center font-bold p-4">
    <p i18n="@@internetStatus.error">
      Connexion internet perdue. Une connexion à internet est nécessaire pour utiliser
      {{ languageService.siteName }} dans les meilleures conditions.
    </p>
  </div>
</div>
}
